import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Contratação',
    path: '/commercial/hirings',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
